import EcoTitle from 'eco-design/base/eco-title';
import { useRef, useEffect, useState } from 'react';
import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { Navigation } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const Accessories: React.FC = () => {
    const { t } = useLang('dpux.Accessories');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-Accessories');
    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999878720/EcoFlow%20Smart%20Home%20Panel%203(32%20Circuits).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000032407/1.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714805551177:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999878317/EcoFlow%20Smart%20Gateway(200A).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000032609/2.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714810073161:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999877478/EcoFlow%20FlowMaster%20Generator%20Rectifier.png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000032882/3.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714823114825:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999878004/EcoFlow%20Generator%20Charging%20Adapter%20(NEMA%20L14-30P%20to%205P8%20Port).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000034059/4.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/40767961530441:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999877646/EcoFlow%20Generator%20Charging%20Adapter%20(NEMA%2014-50P%20to%205P8%20Port).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000034463/5.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714825211977:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999877480/EcoFlow%20Current%20Sense%20Transformer%20(200A).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000033180/6.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714836320329:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999877480/EcoFlow%20Emergencchuy%20Power%20Off%20Button.png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000033729/7.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714837041225:1',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759999879100/EcoFlow%20Smart%20Inlet%20Box%20Connection%20Cable%20(5P8%20Port%20to%205P8%20Port).png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760000033460/8.webp',
            link: 'https://ecoflow-tech.myshopify.com/cart/54714814136393:1',
        },
    ].map((i, idx) => ({ ...i, title: t(`item${idx + 1}`) }));

    /** 动画 */
    const sectionRef = useRef<HTMLDivElement>(null);
    const [enter, setEnter] = useState(false);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current.querySelector('.eco-title');
        const titleAni = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                setEnter(true);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    setEnter(false);
                }
            },
        });

        return () => {
            titleAni.destroy?.();
        };
    }, []);
    return (
        <>
            <section
                className={`${css.section} delta-pro-ultra-x-Accessories dpux-Accessories GtmModuleData-section`}
                id="delta-pro-ultra-x-Accessories"
                data-section-id={'delta-pro-ultra-x-Accessories'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <EcoTitle className="ani-1" title={t('title')} />
                <Swiper
                    className="Accessories-swiper"
                    navigation={{
                        nextEl: '.swiper-btns .swiper-next',
                        prevEl: '.swiper-btns .swiper-prev',
                    }}
                    modules={[Navigation]}
                    slidesPerView={'auto'}
                >
                    {list.map((i, idx) => (
                        <SwiperSlide className={`Accessories-swiper-item item-${idx} ani-1 ${enter ? 'enter' : ''}`} key={i.title}>
                            <EcoImg pc={webpOrJpg(i.img, i.webp)} alt={i.title} />
                            <div className="card-title">{i.title}</div>
                            <EcoLink
                                href={i.link}
                                className="card-btn GtmModuleData-btn-href"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    list_name: t('title'),
                                    product_name: i.title,
                                    button_name: t('buy'),

                                    __btn_id1: `dpux-Accessories .item-${idx} .card-btn`,
                                    __btn_id2: i.link,
                                    __btn_type: 'href',
                                }}
                            >
                                {t('buy')}
                                {/* {t('ComingSoon')} */}
                            </EcoLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="swiper-btns">
                    <div
                        className="swiper-prev tab GtmModuleData-btn-common"
                        data-btn-id="accessories-prev"
                        onClick={() => {
                            gtm.push({
                                __btn_id1: `dpux-Accessories .swiper-prev`,
                                __btn_id2: `accessories-prev`,
                                __btn_type: 'common',
                            });
                        }}
                    >
                        <EcoIconArrow />
                    </div>
                    <div
                        className="swiper-next GtmModuleData-btn-common"
                        data-btn-id="accessories-next"
                        onClick={() => {
                            gtm.push({
                                __btn_id1: `dpux-Accessories .swiper-next`,
                                __btn_id2: `accessories-next`,
                                __btn_type: 'common',
                            });
                        }}
                    >
                        <EcoIconArrow />
                    </div>
                </div>
            </section>
        </>
    );
};

export default Accessories;
